import { formatNumber } from "../../../../utils/utils";

export const generateProjectGroupCSV = (projectGroups, companyData) => {
  const headers = [
    "ID",
    "Project Group Name",
    "Client",
    "Lead",
    "Created (mm/dd/yyyy)",
    "Hours (Act/Est)",
    "Estimated Service Value",
    "Material Value",
    "Total Value",
    "Actual Service Value",
    "Total Cost",
    "Total Invoiced Service Value",
  ];

  const rows = projectGroups.map((group) => {
    const actualHours = group.financials?.expense?.hours || 0;
    const budgetedHours = group.financials?.budget?.hours || 0;
    const actualCost = group.financials?.expense?.cost || 0;
    const totalActualCost = group.financials?.expense?.actualCost || 0;

    const companyName = companyData[group.client] || group.client || "";

    return [
      group.firestoreId,
      group.projectName,
      companyName,
      group.projectLead,
      group.dateCreated,
      `${formatNumber(actualHours)} hrs / ${formatNumber(budgetedHours)} hrs`,
      `$${formatNumber(group.plannerServiceValue) || 0}`,
      `$${formatNumber(group.materialValue) || 0}`,
      `$${formatNumber(group.projectTotal) || 0}`,
      `$${formatNumber(actualCost) || 0}`,
      `$${formatNumber(totalActualCost) || 0}`,
      `$${formatNumber(group.invoiceValue) || 0}`,
    ];
  });

  // Combine headers + rows
  return [
    headers.join(","),
    ...rows.map((r) =>
      r.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
    ),
  ].join("\n");
};
